import { render } from "./AvatarSizeRoundedCircleExample.vue?vue&type=template&id=701d9530&ts=true"
import script from "./AvatarSizeRoundedCircleExample.vue?vue&type=script&lang=ts"
export * from "./AvatarSizeRoundedCircleExample.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__